export const getTranslatedButtonTemplates = (t) => {
 return [
  {
    id: crypto.randomUUID(),
    accentColor: { light: "#000000", dark: "#000000" },
    corners: 32,
    type: "textAndIcon",
    size: "small",
    align: "left",
    label: t("read-more"),
    iconPosition: "left",
    url: "",
    newTab: true,
    labelColor: { light: "#FFFFFF", dark: "#FFFFFF" },
    border: { light: "#000000", dark: "#000000" },
    backgroundColor: { light: "#000000", dark: "#000000" },
    icon: "atlaskit/BookIcon",
    style: "primary",
    styleVariant: "fill"
  },
  {
    id: crypto.randomUUID(),
    accentColor: { light: "#000000", dark: "#000000" },
    corners: 32,
    type: "textAndIcon",
    size: "small",
    align: "left",
    label: t("read-more"),
    iconPosition: "left",
    url: "",
    newTab: true,
    labelColor: { light: "#000000", dark: "#000000" },
    border: { light: "#000000", dark: "#000000" },
    backgroundColor: { light: "#00000000", dark: "#00000000" },
    icon: "atlaskit/BookIcon",
    style: "secondary",
  },
  {
    id: crypto.randomUUID(),
    accentColor: { light: "#000000", dark: "#000000" },
    corners: 32,
    type: "textAndIcon",
    size: "small",
    align: "left",
    label: t("read-more"),
    iconPosition: "right",
    url: "",
    newTab: true,
    labelColor: { light: "#FFFFFF", dark: "#FFFFFF" },
    border: { light: "#000000", dark: "#000000" },
    backgroundColor: { light: "#000000", dark: "#000000" },
    icon: "atlaskit/BookIcon",
    style: "primary",
    styleVariant: "fill"
  },
  {
    id: crypto.randomUUID(),
    accentColor: { light: "#000000", dark: "#000000" },
    corners: 32,
    type: "textAndIcon",
    size: "small",
    align: "left",
    label: t("read-more"),
    iconPosition: "right",
    url: "",
    newTab: true,
    labelColor: { light: "#000000", dark: "#000000" },
    border: { light: "#000000", dark: "#000000" },
    backgroundColor: { light: "#00000000", dark: "#00000000" },
    icon: "atlaskit/BookIcon",
    style: "secondary",
  },
  {
    id: crypto.randomUUID(),
    accentColor: { light: "#000000", dark: "#000000" },
    corners: 32,
    type: "icon",
    size: "small",
    align: "left",
    label: "",
    iconPosition: "right",
    url: "",
    newTab: true,
    labelColor: { light: "#FFFFFF", dark: "#FFFFFF" },
    border: { light: "#000000", dark: "#000000" },
    backgroundColor: { light: "#000000", dark: "#000000" },
    icon: "atlaskit/BookIcon",
    style: "primary",
    styleVariant: "fill"
  },

  {
    id: crypto.randomUUID(),
    accentColor: { light: "#000000", dark: "#000000" },
    corners: 32,
    type: "icon",
    size: "small",
    align: "left",
    label: "",
    iconPosition: "right",
    url: "",
    newTab: true,
    labelColor: { light: "#000000", dark: "#000000" },
    border: { light: "#000000", dark: "#000000" },
    backgroundColor: { light: "#00000000", dark: "#00000000" },
    icon: "atlaskit/BookIcon",
    style: "secondary",
  },
]};

const getStandardColorConfig = (buttonColor) => ({
  accentColor: {
    light: buttonColor.light.accent,
    dark: buttonColor.dark.accent,
  },
  labelColor: {
    light: buttonColor.light.text,
    dark: buttonColor.dark.text,
  },
  border: {
    light: buttonColor.light.accent,
    dark: buttonColor.dark.accent,
  },
  backgroundColor: {
    light: buttonColor.light.accent,
    dark: buttonColor.dark.accent,
  },
});

const getInvertedColorConfig = (buttonColor) => ({
  accentColor: {
    light: buttonColor.light.text,
    dark: buttonColor.dark.text,
  },
  labelColor: {
    light: buttonColor.light.accent,
    dark: buttonColor.dark.accent,
  },
  border: {
    light: buttonColor.light.accent,
    dark: buttonColor.dark.accent,
  },
  backgroundColor: {
    light: buttonColor.light.text,
    dark: buttonColor.dark.text,
  },
});

export const getButtonTemplates = ({
  buttonColor,
  buttonCornerRadius = 32,
  selectedColors,
  isInOverview = false,
  t
}) => {
  const BUTTON_TEMPLATES = getTranslatedButtonTemplates(t);

  const defaultColors = {
    light: {
      accent: isInOverview
        ? selectedColors?.accent?.light || "#000000"
        : buttonColor?.light?.accent,
      text: isInOverview
        ? selectedColors?.text?.light || "#ffffff"
        : buttonColor?.light?.text,
    },
    dark: {
      accent: isInOverview
        ? selectedColors?.accent?.dark || "#000000"
        : buttonColor?.dark?.accent,
      text: isInOverview
        ? selectedColors?.text?.dark || "#ffffff"
        : buttonColor?.dark?.text,
    },
  };

  return BUTTON_TEMPLATES.map((template) => {
    const shouldInvertColors = template.style === "secondary";

    return {
      ...template,
      ...(shouldInvertColors
        ? getInvertedColorConfig(defaultColors)
        : getStandardColorConfig(defaultColors)),
      corners: buttonCornerRadius,
    };
  });
};
